// extracted by extract-css-chunks-webpack-plugin
module.exports = {"children":"children___2aj-w","collapse":"collapse___1xQMi"};